
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models/table-selector",
      function () {
        return require("private-next-pages/models/table-selector.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/models/table-selector"])
      });
    }
  